import React, { createContext, useContext, useState, useCallback } from 'react';
import { Language, translations } from './translations';

interface LanguageContextType {
  language: Language;
  setLanguage: (lang: Language) => void;
  t: (key: string) => string;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [language, setLanguage] = useState<Language>('pt');

  const t = useCallback((key: string): string => {
    const trans = translations[language];
    return (trans as Record<string, string>)[key] || key;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

const fallbackContext: LanguageContextType = {
  language: 'pt',
  setLanguage: () => {},
  t: (key: string) => {
    const trans = translations['pt'];
    return (trans as Record<string, string>)[key] || key;
  },
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  return context || fallbackContext;
};
